<template>
  <div class="router-transitions">
   <!-- Navbar -->
  <nav class="landing-navbar navbar navbar-expand-lg fixed-top landing-navbar-alt bg-white py-1">
    <div class="container px-3">
          <router-link class="navbar-brand text-big font-weight-bolder line-height-1 text-expanded py-3" to="/">{{ institutionName }}</router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#landing-navbar-collapse">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="landing-navbar-collapse">
        <div class="navbar-nav align-items-lg-center ml-auto">
          <router-link class="anchor-link nav-item nav-link" to="/">Home</router-link>
          <router-link class="anchor-link nav-item nav-link" to="application">Apply Now</router-link>
          <div class="nav-item py-3 py-lg-0 ml-lg-4">
             <router-link class="anchor-link btn btn-primary rounded-pill text-expanded" to="/login"><small>SIGN IN</small></router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <!-- / Navbar -->
        <router-view></router-view>
  </div>
</template>

<script>
import SettingService from '../../services/setting.service'

export default {
  name: 'app-layout-public',
  data: () => ({
    institutionName: ''
  }),
  created () {
    SettingService.getGeneralSettings().then(res => {
      this.institutionName = res.data.name
    }).catch(err => console.log(err))
  }
}
</script>
<style>
.landing-navbar {
  transition: all .2s;
}

.landing-navbar .nav-link {
  font-size: .894rem;
}
.font-secondary {
  font-family: "Raleway", -apple-system, BlinkMacSystemFont, "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}
.landing-navbar-alt {
  box-shadow: 0 0 10px rgba(0, 0, 0, .05), 0 1px 0 rgba(24, 28, 33, .04) !important;
}
.landing-btn {
  text-transform: uppercase;
  letter-spacing: .06991em;
  font-weight: 600;
  font-size: 85%;
  font-family: "Raleway", -apple-system, BlinkMacSystemFont, "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}
</style>
